module.exports = __webpack_public_path__ + "media/images/Amsale-Nouvelle-BM-0172c6e2.webp";